import React from 'react';
import './Footer.scss';

export function Footer({ ...rest }) {
  return <footer className={'footer'} {...rest} />;
}
